module.exports = __webpack_public_path__ + "static/img/thumb_18.8b23df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_18.jpg
// module id = bj2X
// module chunks = 0